import React, {Component} from 'react';

export default class Overview extends Component {
  constructor(props) {
    super(props);
  }

  render()
  {
    var st={
      blue:{
        borderRadius:"20px",
            backgroundColor:" #1a84eb",
            borderBottomRightRadius:0,
            borderBottomLeftRadius:0,
            height:"11.1px",

      },
      img:{
        top:0,
        padding:0,
        marginLeft:5
      },

            box:{

              borderRadius: "7px",
              borderTopRightRadius:0,
              borderTopLeftRadius:0,
              backgroundColor:"#ffffff",
              boxShadow: "0 3px 5px 0 rgba(0, 0, 0, 0.3)"
            },
    }

    return(
        <div>
          <div className="img-rounded" style={st.blue}></div>
          <div className="panel panel-default" style={st.box}>
            <div className="panel-body">
                  <h3><strong>OVERVIEW</strong></h3>
              <div >
              <strong>Status : </strong>{this.props.data.stat}
              </div>
              <br />
              <div >
                <strong>Number of Respondents : </strong>{this.props.data.NumberOfResp}
              </div>
              <br />
              <div>
                  <strong>Date Of Start : </strong> {this.props.data.dateOfStart}
              </div>
              <br />

                <img className="img-responsive img-circle col-md-1 " style={st.img} src={this.props.data.image} width="30px" height="30px"/>
                <span className="col-md-10 text-left">
                    <h5><strong>Project Engineer : {this.props.data.ProjEng}</strong></h5>

                </span>

            </div>
          </div>
        </div>
      );
  }
}



/** WEBPACK FOOTER **
 ** ./src/views/clientDashboard/Overview.js
 **/